import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys, type ResponseBody } from '../react-query.config';

export interface QuestionOverride {
  playerId?: string;
  teamId?: string;
  statType: string;
  value: number;
}

type CheckQuestionOverridesResponse = ResponseBody<
  '/api/admin/live-scoring/question/{questionId}/has-overrides',
  'get'
>;

export async function checkQuestionHasOverrides(
  questionId: string
): Promise<CheckQuestionOverridesResponse> {
  return apiClient.get(
    `/api/admin/live-scoring/question/${questionId}/has-overrides` as never
  ) as Promise<CheckQuestionOverridesResponse>;
}

export function useCheckQuestionOverridesQuery(questionId: string | undefined) {
  return useQuery({
    queryKey: [queryKeys.liveScoring.questionHasOverrides(questionId!)],
    queryFn: () => checkQuestionHasOverrides(questionId!),
    enabled: !!questionId,
  });
}
